export const FULLSCREEN_CLASS = 'start-fullscreen';
